module.exports = __webpack_public_path__ + "static/media/tow-hitch-w-trailer.ea951e29.jpg";